export const TID = {
  // nav
  navLogo: "nav-logo",
  navPricing: "nav-pricing",
  navCountries: "nav-countries",
  navLogin: "nav-login",
  navDashboard: "nav-dashboard",
  navLogout: "nav-logout",
  // home
  heroCta: "home-hero-cta",
  heroCtaSecondary: "home-hero-secondary",
  // auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  signupName: "signup-name",
  signupEmail: "signup-email",
  signupWhatsapp: "signup-whatsapp",
  signupPassword: "signup-password",
  signupSubmit: "signup-submit",
  // intake
  intakeHome: "intake-home-university",
  intakeHost: "intake-host-university",
  intakeCountry: "intake-country",
  intakeDuration: "intake-duration",
  intakeStart: "intake-start-date",
  intakeStage: "intake-stage",
  intakeNext: "intake-next",
  intakeBack: "intake-back",
  intakeSubmit: "intake-submit",
  // dashboard
  dashProgress: "dashboard-progress",
  dashVisaCard: "dashboard-visa-card",
  taskItem: (id) => `task-${id}`,
  taskToggle: (id) => `task-toggle-${id}`,
  // countries
  countryCard: (name) => `country-card-${name}`,
  // admin
  adminEdit: (name) => `admin-edit-${name}`,
  adminSave: "admin-save",
  adminReverify: "admin-reverify",
};
